import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { createContext, useContext, useRef, useState } from "react";
import { envChangeType } from "../plugins/utils";

const TawkContext = createContext({
  tawkLoaded: false,
  openTawkChat: () => {},
});

export const TawkContextProvider = ({ children }) => {
  const tawkMessengerRef = useRef();
  const [tawkLoaded, setTawkLoaded] = useState(false);

  const handleTawkLoad = () => {
    const tawkRef = tawkMessengerRef.current;
    if (!tawkRef) return;
    tawkRef.hideWidget();
    setTawkLoaded(true);
  };

  const openTawkChat = () => {
    const tawkRef = tawkMessengerRef.current;
    if (!tawkRef) return;
    tawkRef.maximize();
  };

  return (
    <TawkContext.Provider
      value={{
        //  showTawkWidget, hideTawkWidget,
        tawkLoaded,
        openTawkChat,
      }}
    >
      {children}
      {envChangeType("REACT_APP_TAWK_PROPERTY_ID") === "" ||
      envChangeType("REACT_APP_TAWK_WIDGET_ID") === "" ? null : (
        <TawkMessengerReact
          onLoad={handleTawkLoad}
          propertyId={envChangeType("REACT_APP_TAWK_PROPERTY_ID")} // Replace with your actual property ID
          widgetId={envChangeType("REACT_APP_TAWK_WIDGET_ID")} // Replace with your actual widget ID
          ref={tawkMessengerRef}
          customStyle={{
            visibility: {
              mobile: {
                xOffset: -70,
                position: "br", // 'br', 'bl', 'cr', 'cl', 'tr', 'tl'
              },
            },
          }}
        />
      )}
    </TawkContext.Provider>
  );
};
export const useTawk = () => {
  const TawkValue = useContext(TawkContext);
  return TawkValue;
};
